import useQuestionnaire from 'hooks/useQuestionnaire';
import { checkSpanishLocale, cn } from 'lib/utils';
import { useQuestionnaireStore } from 'store/questionnaire';
import QuestionnaireContainer from './components/QuestionnaireContainer';
import { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import Checkmark from './components/Checkmark';

export default function Smoking() {
  const questionData = useQuestionnaireStore((store) => store.questionData);

  const isSpanish = checkSpanishLocale();

  const { onSubmit, isLoading } = useQuestionnaire();

  const englishChoices = JSON.parse(questionData?.eng_choices || '[]');
  const spanishChoices = JSON.parse(questionData?.spanish_choices || '[]');

  const [selectedIndex, setSelectedIndex] = useState(0);

  const smokeOptions: { en: string; es: string }[] = useMemo(
    () =>
      englishChoices.map((choice: string, index: number) => ({
        en: choice,
        es: spanishChoices[index],
      })),
    [englishChoices, spanishChoices]
  );

  useEffect(() => {
    if (questionData?.user_eng_choices || questionData?.user_spanish_choices) {
      const userChoices =
        questionData?.[isSpanish ? 'user_spanish_choices' : 'user_eng_choices'];

      let answer = '';
      try {
        const parsedChoices = JSON.parse(userChoices);
        answer = parsedChoices[0];
      } catch (error) {
        console.log(error);
      }

      const index = smokeOptions.findIndex((option) => option.en === answer);
      setSelectedIndex(index);
    }
  }, [isSpanish, questionData]);

  const onContinue = async () => {
    const englishChoice = JSON.stringify([smokeOptions[selectedIndex]?.en]);
    const spanishChoice = JSON.stringify([smokeOptions[selectedIndex]?.es]);
    onSubmit({
      choice_value: englishChoice,
      spanish_choice_value: spanishChoice,
      questionData,
    });
  };

  return (
    <QuestionnaireContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={8}
    >
      <div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:gap-6'>
        {smokeOptions?.length
          ? smokeOptions.map((option, index) => {
              const isSelected = index === selectedIndex;

              return (
                <motion.div
                  key={option.en}
                  onClick={() => setSelectedIndex(index)}
                  className={cn(
                    'w-full border-[2px] rounded-2xl px-4 py-2 flex items-center justify-between cursor-pointer text-[#656D76] gap-4',
                    isSelected && 'border-primary text-primary bg-[#E1EBFF]'
                  )}
                  whileTap={{ scale: 0.98 }}
                >
                  <p className='text-sm leading-5'>
                    {option?.[isSpanish ? 'es' : 'en']}
                  </p>

                  <Checkmark isSelected={isSelected} />
                </motion.div>
              );
            })
          : []}
      </div>
    </QuestionnaireContainer>
  );
}
